import { TeContainer, TeContainerSlim } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { PlaceholderContainer } from '@topcon/topcon-utils';
import { useState } from 'react';

import { Section } from '../../utils/styling';
import ViewContainer from '../../components/ViewContainer';
import RenderApps from './RenderApps';
import EmptyApps from './EmptyApps';
import { useOauthClients } from './apps.queries';

function Apps() {
  const { t } = useTranslation('apps');
  const { data: apps, isLoading } = useOauthClients();
  const appsWithoutHidden =
    apps?.items.filter(({ name }: { name: string }) => {
      return name !== '' && name !== 'Devices' && name !== 'Licenses';
    }) || [];
  const appsCount = appsWithoutHidden.length;
  const [searchValue, setSearchValue] = useState('');

  const filteredApps = appsWithoutHidden.filter(({ name }: { name: string }) => {
    const searchMatches = name.toLowerCase().includes(searchValue.toLowerCase());
    return searchMatches;
  });
  const noContent = isLoading || !filteredApps.length;

  const renderLoader = () => {
    return <PlaceholderContainer hasLoader text={t('loadingApps')} />;
  };

  const renderNoApps = () => {
    return <EmptyApps />;
  };

  const renderNoContent = () => {
    return (
      <TeContainerSlim
        backgroundColor="background.secondary"
        borderRadius={4}
        fill
        justifyContent="center"
        alignItems="center"
      >
        {isLoading ? (
          renderLoader()
        ) : !appsCount ? (
          renderNoApps()
        ) : (
          <PlaceholderContainer text={t('noSearchResults')} />
        )}
      </TeContainerSlim>
    );
  };

  return (
    <TeContainerSlim column grow padding="xs" overflow="auto" alignItems="center">
      <Section>
        <ViewContainer
          title={t('apps')}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          visibleItemsText={
            appsCount
              ? t('visibleApps', {
                  filteredApps: filteredApps.length,
                  appsCount,
                })
              : undefined
          }
          searchPlaceholder={t('searchPlaceholder')}
          noPadding
        >
          <TeContainer
            overflow="hidden"
            backgroundColor="background.primary"
            borderRadius={4}
            fill
            column
          >
            {noContent ? (
              renderNoContent()
            ) : (
              <TeContainerSlim column gap="s" overflow="auto" alignItems="normal" fill>
                <RenderApps apps={filteredApps} />
              </TeContainerSlim>
            )}
          </TeContainer>
        </ViewContainer>
      </Section>
    </TeContainerSlim>
  );
}

export default Apps;
